import {
    reactive
} from 'vue'

export const storeEmailForgotPassword = reactive({
    rememberpasswordEmail: "",
})